import { Emit, Inject, Options, Prop, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import { FormPartBData } from "@/trust-atcs-app/models/form-part-b-data";
import RadioButtonHorizontal from "../questions/radiobutton-horizontal/index.vue";
import RadioButtonVertical from "../questions/radiobutton-vertical/index.vue";
import RadioButtonBranchList from "../questions/radiobutton-branchlist/index.vue";
import RadioButtonSubQuestions from "../questions/radiobutton-subquestions/index.vue";
import { ComplianceForm, PartBFormControlledMoney, PartBFormSpecificPowerMoney } from "@/shared/modules/typescript-trustapi-client/models";
import InputTextNumberCurrency from "../questions/input-text-number-currency/index.vue";
import FileUploader from "../questions/file-uploader/index.vue";

@Options({
  components: {
    LoadingSpinner,
    RadioButtonVertical,
    RadioButtonHorizontal,
    RadioButtonBranchList,
    RadioButtonSubQuestions,
    InputTextNumberCurrency,
    FileUploader,
  },
  mixins: [FormatDateTimeMixin],
})
export default class FormPartBSpecificPowerMoney extends Vue {

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Prop()
  private formPartBData!: FormPartBData;

  @Emit('update:isSectionLoading')
  @Emit('validForm')

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private validMainQuestions: boolean[] = [];
  private specificPowerMoney: PartBFormSpecificPowerMoney = null as any;

  mounted(): void {
    this.eventCtrl.on('reload-form-b-spm-content', this.loadSpecificPowerMoneyContent);
    this.loadSpecificPowerMoneyContent();
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-b-spm-content', this.loadSpecificPowerMoneyContent);
  }

  private async loadSpecificPowerMoneyContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetSpecificPowerMoneyPost({
        complianceFormId: this.complianceFormB.id,
        updatingKey: this.updatingKey,
        manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
      });
      this.specificPowerMoney = resp.data.data as PartBFormControlledMoney;
      this.formPartBData.specificPowerMoney = this.specificPowerMoney as any;

      // Sort atcsMainQuestions by order number
      this.formPartBData.specificPowerMoney.atcsMainQuestions = this.formPartBData.specificPowerMoney.atcsMainQuestions.sort((a: any, b: any) => a.order - b.order);
      // Sort atcsSubQuestions by order number
      this.formPartBData.specificPowerMoney.atcsMainQuestions.forEach((q: any) => {
        q.atcsSubQuestions = q.atcsSubQuestions.sort((a: any, b: any) => a.order - b.order);
      });
      // Sort response by order number
      this.formPartBData.specificPowerMoney.atcsMainQuestions.forEach((q: any) => {
        q.responses = q.responses.sort((a: any, b: any) => a.order - b.order);
      });

      this.validMainQuestions = this.formPartBData.specificPowerMoney.atcsMainQuestions.map((q: any) => false);
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting General Trust Money');
      this.ai.trackException('Error getting General Trust Money: ' + err);
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private validForm(): boolean {
    return !this.validMainQuestions.includes(false);
  }

  private validationForm(i: any, isValid: any) {
    this.validMainQuestions[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}



